"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TestimonialsLayout = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _utils = require("../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const TestimonialsLayout = (param)=>{
    let { data, debug, modulePosition, className } = param;
    const isMobile = (0, _presentationHooks.useIsMobile)();
    const { getTestId } = (0, _testidGenerator.default)();
    const carouselOptions = (0, _react.useMemo)(()=>({
            navigation: {
                position: 'inside',
                showArrows: !isMobile
            },
            autoplay: {
                enabled: true,
                interval: _constants.TESTIMONIAL_CAROUSEL_INTERVAL
            },
            slider: {
                loop: true
            }
        }), [
        isMobile
    ]);
    if (!(data === null || data === void 0 ? void 0 : data.collection) || data.collection.length < 1) {
        return (0, _utils.getModulesContentError)({
            debug,
            modulePosition,
            layout: _constants.TESTIMONIAL_MODULE_NAME
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.Carousel, {
        ...carouselOptions,
        id: _constants.TESTIMONIAL_CAROUSEL_ID,
        children: data.collection.map((param)=>{
            let { textCollection, title, image, author, showStarRating } = param;
            var _textCollection_;
            var _image_urlMobile, _ref, _image_url;
            const imageUrl = isMobile ? (_ref = (_image_urlMobile = image === null || image === void 0 ? void 0 : image.urlMobile) !== null && _image_urlMobile !== void 0 ? _image_urlMobile : image === null || image === void 0 ? void 0 : image.url) !== null && _ref !== void 0 ? _ref : '' : (_image_url = image === null || image === void 0 ? void 0 : image.url) !== null && _image_url !== void 0 ? _image_url : '';
            const hasImage = Boolean(imageUrl);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.CarouselSlide, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
                    className: className,
                    "data-testid": getTestId(_constants.TESTIMONIAL_CAROUSEL_SLIDE),
                    children: [
                        hasImage ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ImageWrapper, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Image, {
                                "data-testid": getTestId(_constants.TESTIMONIAL_CAROUSEL_IMAGE),
                                src: imageUrl
                            })
                        }) : null,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ContentWrapper, {
                            hasImage: hasImage,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.ContentInner, {
                                hasImage: hasImage,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Title, {
                                        "data-testid": getTestId(_constants.TESTIMONIAL_CAROUSEL_TITLE),
                                        children: title
                                    }),
                                    showStarRating ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.StarRating, {
                                        "data-testid": getTestId(_constants.TESTIMONIAL_CAROUSEL_STARS),
                                        max: 5,
                                        value: 5
                                    }) : null,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Description, {
                                        "data-testid": getTestId(_constants.TESTIMONIAL_CAROUSEL_DESCRIPTION),
                                        variant: "subtitle1",
                                        children: textCollection === null || textCollection === void 0 ? void 0 : (_textCollection_ = textCollection[0]) === null || _textCollection_ === void 0 ? void 0 : _textCollection_.text
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.NameAndCountry, {
                                        "data-testid": getTestId(_constants.TESTIMONIAL_CAROUSEL_AUTHOR),
                                        variant: "body1",
                                        children: author
                                    })
                                ]
                            })
                        })
                    ]
                })
            }, title);
        })
    });
};
exports.TestimonialsLayout = TestimonialsLayout;
